import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = _Reflect$construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { EventEmitter } from "eventemitter3";
import noop from "lodash/noop";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import { createContextConsumerHOC } from "@jutro/platform";
import { AlertModal } from "./AlertModal/AlertModal";
import { ConfirmationModal } from "./ConfirmationModal/ConfirmationModal";
import { getModalRoot } from "./helpers/modalHelpers";
import { ModalNext } from "./ModalNext";
import { ModalNextContext } from "./ModalNextContext";
import { useModalPromise } from "./useModalPromise";
var methods = ["showAlert", "showConfirm", "showModal"];
export var ModalNextEmitter = function (_EventEmitter) {
  _inherits(ModalNextEmitter, EventEmitter);
  var _super = _createSuper(ModalNextEmitter);
  function ModalNextEmitter() {
    return _classCallCheck(this, ModalNextEmitter), _super.apply(this, arguments);
  }
  return _createClass(ModalNextEmitter, [{
    key: "showAlert",
    value: function () {
      for (var _this = this, _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
      return new _Promise(function (resolve, reject) {
        _this.emit("showAlert", {
          method: "showAlert",
          args: args,
          resolve: resolve,
          reject: reject
        });
      });
    }
  }, {
    key: "showConfirm",
    value: function () {
      for (var _this2 = this, _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
      return new _Promise(function (resolve, reject) {
        _this2.emit("showConfirm", {
          method: "showConfirm",
          args: args,
          resolve: resolve,
          reject: reject
        });
      });
    }
  }, {
    key: "showModal",
    value: function () {
      for (var _this3 = this, _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) args[_key3] = arguments[_key3];
      return new _Promise(function (resolve, reject) {
        _this3.emit("showModal", {
          method: "showModal",
          args: args,
          resolve: resolve,
          reject: reject
        });
      });
    }
  }]), ModalNextEmitter;
}();
export var withModalContext = function (Component) {
  return createContextConsumerHOC({
    component: Component,
    context: ModalNextContext,
    displayName: "withModalContext(".concat(Component.displayName || Component.name, ")"),
    mapContextToProps: function (props, modalContext) {
      return {
        modalContext: modalContext
      };
    }
  });
};
export var ModalNextProvider = function (_ref) {
  var emitter = _ref.emitter,
    children = _ref.children,
    appElementId = _ref.appElementId,
    modalFunctions = _ref.modalFunctions,
    portalClassName = _ref.portalClassName,
    _useModalPromise = useModalPromise(),
    _useModalPromise2 = _slicedToArray(_useModalPromise, 4),
    isOpenAlert = _useModalPromise2[0],
    showAlertPromise = _useModalPromise2[1],
    resolveAlert = _useModalPromise2[2],
    rejectAlert = _useModalPromise2[3],
    _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    alertRender = _useState2[0].alertRender,
    setAlertState = _useState2[1],
    _useModalPromise3 = useModalPromise(),
    _useModalPromise4 = _slicedToArray(_useModalPromise3, 4),
    isOpenModal = _useModalPromise4[0],
    showModalPromise = _useModalPromise4[1],
    resolveModal = _useModalPromise4[2],
    rejectModal = _useModalPromise4[3],
    _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    modalRender = _useState4[0].modalRender,
    setModalState = _useState4[1];
  ModalNext.handleAfterClose = useCallback(function () {
    isOpenAlert || setAlertState({}), isOpenModal || setModalState({});
  }, [isOpenAlert, isOpenModal, setAlertState, setModalState]);
  var context = useMemo(function () {
    return _objectSpread(_objectSpread({
      showAlert: function (_ref2) {
        var status = _ref2.status,
          icon = _ref2.icon,
          title = _ref2.title,
          message = _ref2.message,
          confirmButtonText = _ref2.confirmButtonText;
        return setAlertState({
          alertRender: function (alertProps) {
            return React.createElement(AlertModal, _extends({}, alertProps, {
              parentSelector: getModalRoot,
              title: title,
              message: message,
              status: status,
              icon: icon,
              confirmButtonText: confirmButtonText
            }));
          }
        }), showAlertPromise();
      },
      showConfirm: function (_ref3) {
        var status = _ref3.status,
          icon = _ref3.icon,
          title = _ref3.title,
          message = _ref3.message,
          confirmButtonText = _ref3.confirmButtonText,
          cancelButtonText = _ref3.cancelButtonText;
        return setAlertState({
          alertRender: function (alertProps) {
            return React.createElement(ConfirmationModal, _extends({}, alertProps, {
              parentSelector: getModalRoot,
              title: title,
              message: message,
              status: status,
              icon: icon,
              confirmButtonText: confirmButtonText,
              cancelButtonText: cancelButtonText
            }));
          }
        }), showAlertPromise();
      },
      showModal: function (component) {
        return setModalState({
          modalRender: function (modalProps) {
            return React.cloneElement(component, modalProps);
          }
        }), showModalPromise();
      }
    }, modalFunctions), {}, {
      portalClassName: portalClassName
    });
  }, [portalClassName, showAlertPromise, setAlertState, showModalPromise, setModalState, modalFunctions]);
  return useEffect(function () {
    document.getElementById(appElementId) && ReactModal.setAppElement("#".concat(appElementId));
  }, [appElementId]), useEffect(function () {
    if (!emitter) return noop;
    var methodListener = function (_ref4) {
      var method = _ref4.method,
        args = _ref4.args,
        resolve = _ref4.resolve,
        reject = _ref4.reject;
      context[method].apply(context, _toConsumableArray(args)).then(resolve).catch(reject);
    };
    return methods.forEach(function (method) {
      return emitter.addListener(method, methodListener, context);
    }), function () {
      methods.forEach(function (method) {
        return emitter.removeListener(method, methodListener, context);
      });
    };
  }, [emitter, context]), React.createElement(ModalNextContext.Provider, {
    value: context
  }, children, alertRender && alertRender({
    isOpen: isOpenAlert,
    onResolve: resolveAlert,
    onReject: rejectAlert
  }), modalRender && modalRender({
    isOpen: isOpenModal,
    onResolve: resolveModal,
    onReject: rejectModal
  }));
};
ModalNextProvider.propTypes = {
  appElementId: PropTypes.string,
  children: PropTypes.node,
  emitter: PropTypes.instanceOf(ModalNextEmitter),
  portalClassName: PropTypes.string
}, ModalNextProvider.defaultProps = {
  appElementId: "root"
};
export var useModal = function () {
  var context = useContext(ModalNextContext);
  if (!context) throw new Error("useModal should be used only in components wrapped in the ModalNextProvider");
  return context;
};
ModalNextProvider.__docgenInfo = {
  description: "@type {React.FC<import('/types').ModalNextProviderProps>}",
  methods: [],
  displayName: "ModalNextProvider",
  props: {
    appElementId: {
      defaultValue: {
        value: "'root'",
        computed: !1
      },
      type: {
        name: "string"
      },
      required: !1,
      description: 'ID of the root element of your app, used to hide the app from accessibility tools on modal popup.\nThe root element must not be a parent of the modal root (from getModalRoot()), or else the content of the modal will be hidden as well.\nDefaults to `"root"`'
    },
    children: {
      type: {
        name: "node"
      },
      required: !1,
      description: ""
    },
    emitter: {
      type: {
        name: "instanceOf",
        value: "ModalNextEmitter"
      },
      required: !1,
      description: "Instance of ModalNextEmitter passed down to ModalNextProvider for accessing modal functions from outside the scope of the ModalNextProvider"
    },
    portalClassName: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Class name for the modal portal container"
    }
  }
}, ModalNextProvider.__docgenInfo = {
  componentName: "ModalNextProvider",
  packageName: "@jutro/components",
  description: "",
  displayName: "ModalNextProvider",
  methods: [],
  actualName: "ModalNextProvider",
  props: {
    appElementId: {
      type: {
        name: "string"
      },
      required: !1,
      description: 'ID of the root element of your app, used to hide the app from accessibility tools on modal popup.\nThe root element must not be a parent of the modal root (from getModalRoot()), or else the content of the modal will be hidden as well.\nDefaults to `"root"`',
      defaultValue: {
        value: "'root'",
        computed: !1
      }
    },
    children: {
      type: {
        name: "node"
      },
      required: !1,
      description: ""
    },
    emitter: {
      type: {
        name: "instanceOf",
        value: "ModalNextEmitter"
      },
      required: !1,
      description: "Instance of ModalNextEmitter passed down to ModalNextProvider for accessing modal functions from outside the scope of the ModalNextProvider"
    },
    portalClassName: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Class name for the modal portal container"
    }
  }
};